export const stats = [
  {
    id: 'jobs',
    value: 3.5,
    suffix: 'M+',
    label: 'Global Cybersecurity Job Openings',
    description: 'Unfilled positions worldwide',
  },
  {
    id: 'salary',
    value: 107,
    prefix: '$',
    suffix: 'k',
    label: 'Median SOC Analyst Salary',
    description: 'US national average',
  },
  {
    id: 'weeks',
    value: 8,
    suffix: ' Wks',
    label: 'To Completion',
    description: 'Focused, accelerated format',
  },
  {
    id: 'unemployment',
    value: 0,
    suffix: '%',
    label: 'Cybersecurity Unemployment',
    description: 'Consistent industry demand',
  },
  {
    id: 'hours',
    value: 120,
    suffix: ' hrs',
    label: 'Clock Hours - Cyber Ops',
    description: '~15 hours per week',
  },
  {
    id: 'starting',
    value: 85,
    prefix: '$',
    suffix: 'k+',
    label: 'Avg. Starting Salary',
    description: 'Regional market data',
  },
];